<template>
    <ModalContainer>
        <div class="relative bg-white rounded-lg shadow p-4 max-w-xl w-full">
            <div class="flex items-start justify-between p-4 rounded-t">
                <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
                    User Status
                </h3>
                <button type="button"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
                    @click="close()">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
            <!-- Modal body -->
            <div class="p-6 space-y-6">
                <SelectGroup class="mb-3" name="status" label="User Status" v-model="selectedStatus" :options="getUserStatuses()" />
                <InputGroup v-if="!statusWithoutMessage.includes(selectedStatus)" name="statusMessage" type="text" label="Status Message" v-model="statusMessage" />
            </div>
            <!-- Modal Footer -->
            <div class="flex justify-end p-6 space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600">
                <ButtonPrimary @click.prevent="updateStatus">Update</ButtonPrimary>
            </div>
        </div>
    </ModalContainer>
</template>
<script>
import ModalContainer from '@/components/modal/ModalContainer.vue';

export default {
    props: {
        userId: {},
        status: {
            default: 'available',
        },
        close: {
            default: () => { },
        }
    },
    data() {
        return {
            statusWithoutMessage: ['pending', 'available'],
            selectedStatus: this.status,
            statusMessage: '',
        };
    },
    methods: {
        async updateStatus() {
            const response = await this.httpRequest(`/organizer/user/${this.userId}/status`, 'post', {
                data: {
                    status: this.selectedStatus,
                    statusMessage: !this.statusWithoutMessage.includes(this.selectedStatus) ? this.statusMessage : undefined,
                }
            });
            if (response.result === 'success') {
                this.close(true);
            }
        },
    },
    components: { ModalContainer }
}
</script>